<template>
  <v-data-table
    :items="items"
    :headers="getHeaders"
    :search="search"
    :mobile-breakpoint="0"
    :items-per-page="items.length + 1"
    hide-default-footer
    sort-by="nom"
  >
    <template v-slot:item.nom="{ item }">
      <span class="font-weight-bold">{{ item.nom }}</span>
    </template>
    <template v-slot:item.orderNumber="{ item }">
      <span
        class="font-weight-bold caption
      "
        >{{ item.data ? item.data.order_number : "" }}</span
      >
    </template>
    <template v-slot:item.mobile="{ item }">
      <div>
        <v-row dense no-gutters>
          <span class="font-weight-bold caption"
            >{{ item.nom }}
            {{
              item.data && item.data.order_number !== null
                ? `(${item.data.order_number})`
                : ""
            }}</span
          >
        </v-row>
        <v-row dense no-gutters>
          <span>{{ item.quantity_ordered }}</span>
          <span class="caption ml-1">{{ item.mapped_unit }}</span>
        </v-row>
      </div>
    </template>
    <template v-slot:item.quantity_ordered="{ item }">
      <span>{{ item.quantity_ordered }}</span>
      <span class="caption ml-1">{{ item.mapped_unit }}</span>
    </template>
    <template v-slot:item.quantity_received="{ item }">
      <v-row align="center" no-gutters v-if="!deliverySlip.is_closed">
        <j-decimal-input
          filled
          single-line
          hide-details
          dense
          style="max-width: 175px;"
          class="no-before my-1"
          unit-suffix
          :suffix="item.mapped_unit"
          v-model="item.quantity_received"
        ></j-decimal-input>
      </v-row>
      <div v-else>
        <span>{{ item.quantity_received }}</span>
        <span class="caption ml-1">{{ item.mapped_unit }}</span>
      </div>
    </template>
    <template v-slot:item.actions="{ item }">
      <v-row
        class="px-0"
        align="center"
        justify="center"
        no-gutters
        v-if="item.quantity_ordered > 0 && $vuetify.breakpoint.xsOnly"
      >
        <v-btn
          v-if="item.quantity_received < 1"
          icon
          :disabled="deliverySlip.is_closed"
          @click="item.quantity_received = item.quantity_ordered"
        >
          <v-icon>far fa-square</v-icon>
        </v-btn>
        <v-btn
          v-else
          icon
          color="success"
          :disabled="deliverySlip.is_closed"
          @click="item.quantity_received = 0"
        >
          <v-icon>fa-square</v-icon>
        </v-btn>
      </v-row>
      <v-row
        align="center"
        justify="center"
        no-gutters
        v-else-if="item.quantity_ordered > 0"
      >
        <v-hover v-slot:default="{ hover }" v-if="item.quantity_received < 1">
          <v-btn
            icon
            :disabled="deliverySlip.is_closed"
            @click="item.quantity_received = item.quantity_ordered"
          >
            <v-icon v-if="!hover">far fa-square</v-icon>
            <v-icon v-else>fa-plus-square</v-icon>
          </v-btn>
        </v-hover>
        <v-hover v-slot:default="{ hover }" v-else>
          <v-btn
            icon
            color="success"
            :disabled="deliverySlip.is_closed"
            @click="item.quantity_received = 0"
          >
            <v-icon v-if="!hover">fa-square</v-icon>
            <v-icon v-else>fa-minus-square</v-icon>
          </v-btn>
        </v-hover>
      </v-row>
    </template>
    <template v-slot:item.quantity_inv="{ item }">
      <span>{{ getInvQty(item) }}</span>
      <span class="caption ml-1">{{ getInvUnit(item) }}</span>
    </template>
    <template v-slot:top>
      <v-row align="center" class="no-print" justify="end" dense>
        <v-col cols="12" sm="6">
          <v-text-field
            dense
            filled
            hide-details
            single-line
            clearable
            prepend-inner-icon="fa-search"
            v-model="search"
            class="no-before"
          ></v-text-field>
        </v-col>
      </v-row>
    </template>
  </v-data-table>
</template>

<script>
import { mappers } from "@/mappers";
export default {
  name: "DeliverySlipViewerGrid",
  props: {
    items: {
      type: Array,
      required: true
    },
    deliverySlip: {
      required: true
    }
  },
  computed: {
    getHeaders() {
      if (this.$vuetify.breakpoint.xsOnly) {
        return [
          {
            value: "actions",
            text: "",
            width: 40,
            class: ["px-0"],
            sortable: false
          },
          {
            value: "mobile",
            sortable: false
          },
          {
            value: "quantity_received",
            text: "Reçu",
            sortable: false,
            width: 150
          }
        ];
      } else {
        return [
          {
            value: "actions",
            text: "",
            width: 40,
            class: ["px-0"],
            sortable: false
          },
          { value: "nom", text: "Produit", width: 200 },
          { value: "orderNumber", text: "# commande" },
          {
            value: "quantity_ordered",
            text: "Commande",
            sortable: false
          },
          {
            value: "quantity_received",
            text: "Reçu",
            sortable: false,
            width: 150
          },
          {
            value: "quantity_inv",
            text: "(conversion)",
            sortable: false,
            align: "end",
            width: 100
          }
        ];
      }
    }
  },
  data() {
    return {
      search: "",
      headers: [
        {
          value: "actions",
          text: "",
          width: 40,
          class: ["px-0"],
          sortable: false
        },
        { value: "nom", text: "Produit", width: 100 },
        { value: "orderNumber", text: "# commande" },
        {
          value: "quantity_ordered",
          text: "Commande",
          sortable: false
        },
        {
          value: "quantity_received",
          text: "Reçu",
          sortable: false
        },
        {
          value: "quantity_inv",
          text: "(conversion)",
          sortable: false,
          align: "end"
        }
      ]
    };
  },
  methods: {
    getUnit(item) {
      if (item.data) {
        if (item.data.use_order_quantity) {
          return item.data.unite_mesure_order;
        } else {
          return item.data.unite_mesure_inventory;
        }
      } else {
        return "";
      }
    },
    getInvQty(item) {
      if (item.data) {
        if (item.data.use_order_quantity) {
          return mappers.productOrderToInv(item.quantity_received, item.data);
        }
      }
      return "";
    },
    getInvUnit(item) {
      if (item.data) {
        if (item.data.use_order_quantity) {
          return item.data.unite_mesure_inventory;
        }
      }
      return "";
    }
  }
};
</script>

<style></style>
